export default "__VITE_ASSET__BNsZGpyz__"